import React from 'react';

import '../CSS/calltoaction.css';

const CallToAction: React.FC<{ element: any }> = ({ element }) => {
  const externalUrl =
    element.link?.linkedItems[0]?.elements?.external_url?.value;
  const internalSlug =
    element.link?.linkedItems[0]?.elements?.internal_link?.linkedItems[0]
      ?.elements?.url_slug?.value;
  const internalUrl = internalSlug
    ? `${window.location.origin}/en-us/learningobject/${internalSlug}`
    : null;
  const newWindow =
    element.link?.linkedItems[0]?.elements?.open_in_new_window_?.value?.[0]
      ?.name;

  const handleClick = (): void => {
    if (externalUrl) {
      window.open(externalUrl, newWindow === 'Yes' ? '_blank' : '_self');
    } else if (internalUrl) {
      window.open(internalUrl, newWindow === 'Yes' ? '_blank' : '_self');
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        paddingBottom: '10px',
      }}
    >
      <button className="cta-content-button" onClick={handleClick}>
        {element.action_label.value || 'Click Here'}
      </button>
    </div>
  );
};

export default CallToAction;
